import { render, staticRenderFns } from "./BaseResumeInfos.vue?vue&type=template&id=5ff0e49e&scoped=true&"
import script from "./BaseResumeInfos.vue?vue&type=script&lang=js&"
export * from "./BaseResumeInfos.vue?vue&type=script&lang=js&"
import style0 from "./BaseResumeInfos.vue?vue&type=style&index=0&id=5ff0e49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0e49e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
